export const theme = {
  colors: {
    bg: "#161512",
    primaryText: "#F1E6D3",
    primaryText07: "rgba(241, 230, 211, 0.7)",
    primaryText03: "rgba(241, 230, 211, 0.3)",
    primaryText02: "rgba(241, 230, 211, 0.2)",
    highlightedText: "#F9CD11",
  },

  fontSize: {
    // header: "32px",
    // h1: "36px",
  },
};
